import React, { Fragment, useState, forwardRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLazyQuery } from '@apollo/client';

import { Button } from '@BICE_Vida/components';

import { useBranding } from '@/src/customHooks';
import Text from '../../designSystem/Text';
import CircleLoader from '../CircleLoader';

import styles from './PlansRetry.module.scss';

import componentsId from '../../utils/componentsId';
import { plansRetryTexts } from '../../utils/generalTexts';
import { delayLoader } from '../../utils/constants';

import * as appSelectors from '../../redux/app/selectors';
import * as appActions from '../../redux/app/actions';
import * as ufActions from '../../redux/uf/actions';
import * as plansActions from '../../redux/plans/actions';
import listPlansAndUFToday from '../../graphQL/queries/listPlansAndUFToday';
import { ICON_WORKING } from '../../utils/assets';

function PlansRetry(_props: any, ref?: any) {
  const dispatch = useDispatch();
  const branding = useBranding();
  const loading = useSelector(appSelectors.getLoading);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  const [getInitialData] = useLazyQuery(listPlansAndUFToday, {
    onCompleted: (data) => {
      setIsLoading(false);

      if (data) {
        dispatch(plansActions.setAvailablePlans(data.listPlans));
        dispatch(ufActions.setUF(data.getUFToday));
        dispatch(appActions.unsetError());

        if (ref) {
          ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    },
    onError: (error) => {
      setIsLoading(false);
      dispatch(appActions.setError(error));
    },
  });

  const handleRetryClick = () => {
    setIsLoading(true);

    setTimeout(() => {
      getInitialData({ variables: { brokerCode: branding.code } });
    }, delayLoader);
  };

  return (
    <div className={styles.plans_retry_container}>
      {isLoading ? (
        <Fragment>
          <CircleLoader />
          <div className={styles.plans_retry_loading_text_container}>
            <Text text={plansRetryTexts.loading} customClass={styles.plans_retry_description} />
          </div>
        </Fragment>
      ) : (
        <Fragment>
          <img src={ICON_WORKING} alt="fallback plans icon" className={styles.plans_retry_icon} />

          <div className={styles.plans_retry_description_container}>
            <Text text={plansRetryTexts.description} customClass={styles.plans_retry_description} />
          </div>

          <div className={styles.plans_retry_button_container}>
            <Button
              id={componentsId.plansRetryBtn}
              text={plansRetryTexts.button}
              variant="text"
              onClick={handleRetryClick}
              size="large"
            />
          </div>
        </Fragment>
      )}
    </div>
  );
}

export default forwardRef(PlansRetry);
